import { RoutingRuleAssignmentTargetType, RoutingRuleBillAggregationType } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { createHandler } from '@mews/std';

export const getTargetDescription = (
    assignmentType: RoutingRuleAssignmentTargetType,
    aggregationType: RoutingRuleBillAggregationType
) => {
    if (assignmentType === RoutingRuleAssignmentTargetType.NoCompany) {
        return null;
    }

    if (assignmentType === RoutingRuleAssignmentTargetType.CompanyAsDetails) {
        return lt('RoutingRulesGuestBillCompanyAsDetailsDescription');
    }

    return {
        [RoutingRuleBillAggregationType.AggregateAll]: lt('RoutingRulesCompanyBillAggregateAllDescription'),
        [RoutingRuleBillAggregationType.AggregateByCustomer]: lt(
            'RoutingRulesCompanyBillAggregateByCustomerDescription'
        ),
        [RoutingRuleBillAggregationType.OnePerReservation]: lt('RoutingRulesCompanyBillOnePerReservationDescription'),
        [RoutingRuleBillAggregationType.AggregatePerReservationGroup]: lt(
            'RoutingRulesCompanyBillAggregatePerReservationGroupDescription'
        ),
    }[aggregationType];
};

export const getTargetTitle = createHandler<RoutingRuleAssignmentTargetType, React.ReactNode>({
    [RoutingRuleAssignmentTargetType.CompanyAsDetails]: lt('RoutingRulesGuestBill'),
    [RoutingRuleAssignmentTargetType.NoCompany]: lt('RoutingRulesGuestBill'),
    [RoutingRuleAssignmentTargetType.CompanyAsOwner]: lt('RoutingRulesCompanyBill'),
});
